export function getDirectvPackage(dtvPackageID) {
  return { path: `directv_packages/${dtvPackageID}` };
}

export function searchDirectvPackages(query) {
  return { path: `directv_packages${query}` };
}

export function createDirectvPackage(name) {
  return {
    path: 'directv_packages',
    method: 'POST',
    body: JSON.stringify({ name }),
  };
}

export function updateDirectvPackage(dtvPackageID, newName) {
  return {
    body: JSON.stringify({ name: newName }),
    path: `directv_packages/${dtvPackageID}`,
    method: 'PUT',
  };
}

export function deleteDirectvPackage(dtvPackageID) {
  return {
    path: `directv_packages/${dtvPackageID}`,
    method: 'DELETE',
  };
}
